import { router } from 'ui-utilities';
import { getSpamTokens } from '../helpers/spam-protection';

export default function RegistrationCard(el, {
    recaptchaSiteKey,
    turnstileSiteKey,
    actions,
    events,
}) {
    const form = el.querySelector('form');
    const submit = form.querySelector('[type="submit"]');

    let processing = false;

    function handleSubmit(e) {
        e.preventDefault();

        if (processing) {
            return;
        }

        processing = true;
        submit.setAttribute('disabled', true);

        const formData = new FormData();
        formData.append('action', 'forms-module/forms/validate');

        getSpamTokens({
            recaptchaSiteKey,
            turnstileSiteKey,
            action: 'registration',
            container: form,
        }).then(({ recaptchaToken, turnstileToken }) => {
            formData.append('recaptchaToken', recaptchaToken);
            formData.append('recaptchaAction', 'registration');
            formData.append('turnstileToken', turnstileToken);

            events.emit(actions.getCsrfToken, {
                cb: ({ name, value }) => {
                    formData.append(name, value);
                    router.post({
                        formData,
                        cb: res => {
                            const { success, recaptcha, turnstile } = JSON.parse(res);

                            processing = false;
                            submit.removeAttribute('disabled');

                            if (!success) {
                                window.alert('Validation failed. Please try again.');
                                console.log(`recaptcha: ${recaptcha}, turnstile: ${turnstile}`);

                                return;
                            }

                            form.insertAdjacentHTML('afterbegin', '<input type="hidden" name="action" value="users/save-user" />');
                            form.insertAdjacentHTML('afterbegin', `<input type="hidden" name="${name}" value="${value}" />`);
                            form.submit();
                        },
                    });
                },
            });
        }).catch(err => {
            processing = false;
            submit.removeAttribute('disabled');
            console.error('Spam protection error:', err);
            window.alert('Verification failed. Please try again.');
        });
    }

    form.addEventListener('submit', handleSubmit);
}
